import React from "react";
import LoadingButton from "../../components/LoadingButton";
import { View, Text } from "react-native";
import { isWeb } from "../common/utils/platform.util";

interface ToggleEnableButtonProps {
  isEnabled: boolean;
  onToggle: () => void;
  isLoading?: boolean;
}

const ToggleEnableButton: React.FC<ToggleEnableButtonProps> = ({
  isEnabled,
  onToggle,
  isLoading,
}) => (
  <View style={{ alignItems: "center", marginVertical: isWeb ? 4 : 20 }}>
    <LoadingButton
      onPress={onToggle}
      backgroundColor={isEnabled ? "#FBD644" : "#008000bf"}
      textStyle={{ color: "black" }}
      isLoading={isLoading}
    >
      <Text className="text-lg font-bold text-center text-black">
        {isEnabled ? "Pause MeanderEV Services" : "Resume MeanderEV Services"}
      </Text>
    </LoadingButton>
  </View>
);

export default ToggleEnableButton;
